import TextArea from '../../../../shared/FormElements/TextAreas/TextArea';

function WarrantyFormMessage() {
  return (
    <TextArea
      name="message"
      label="Additional details"
      placeholder="Provide ALL additional details about the fit issues, when they occur, or ALL other relevant information..."
      required
      rows={4}
    />
  );
}

export default WarrantyFormMessage;
